import React from 'react';
import { Typography, TypographyVariants } from '@hallmark/web.core.typography.typography';
import { EyebrowProps, HtmlTagOverrides } from '../tabs-types';
import styles from '../tabs.module.scss';

export function Eyebrow({
  text,
  color,
  eyebrowTag = HtmlTagOverrides.P,
  testId = 'eyebrow-testid',
}: EyebrowProps): React.ReactElement {
  return (
    <Typography
      variant={TypographyVariants.Eyebrow}
      addClass={styles.eyebrow}
      htmlTagOverride={eyebrowTag}
      color={color}
      data-testid={testId}
    >
      {text}
    </Typography>
  );
}
